/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import * as React from "react";
import styled from "styled-components";

import { theme as siteTheme } from "../theme/theme";

type ErrorMessageProps = {
  errorMessage: string;
  testId: string;
};

const StyledError = styled.p`
  color: ${siteTheme.color.red};
  margin-bottom: 0px;
`;

const ErrorMessage = ({
  testId,
  errorMessage,
}: ErrorMessageProps): React.ReactElement => {
  return <StyledError data-testid={testId}>{errorMessage}</StyledError>;
};

export default ErrorMessage;
